import './learn.scss'
import React from 'react'
import { Container, Grid, Button, Typography } from '@material-ui/core'
import { Timelapse } from '@material-ui/icons'
import MakesBetter from 'components/MakesBetter'
import HeadeImage from '../../assets/Images/shapes.png'
import DarkModeHeaderImg from '../../assets/Images/DarkModeLearnBackground.png'
import useDarkMode from 'use-dark-mode'
import { convertDate, convertMarkdownToText, readingTime } from './utils'
import { Link } from 'react-router-dom'
import styled from '@emotion/styled-base'
import { HashLink } from 'react-router-hash-link'
import QueryWrapper from 'components/querywrapper'
import useSWR from 'swr'
import * as qs from 'qs'
import { useFetchPage, useLocale } from 'hooks'
import RedSquare from 'components/RedSquare'
import CallToAction from 'components/CallToAction'
import { H2Bold } from 'components/Typography/Basic'

const { REACT_APP_STRAPI_API_URL } = process.env

function Learn() {
  const darkMode = useDarkMode()
  const { locale } = useLocale()

  const query = qs.stringify({
    locale: [locale],
    populate: {
      herosection: {
        populate: {
          cover: {
            fields: ['url']
          },
          DarkModeCover: {
            fields: ['url']
          },
          button: {
            fields: ['title']
          }
        }
      }
    }
  })

  const fetcher = () =>
    fetch(`${REACT_APP_STRAPI_API_URL}/api/avax-learnpage?${query}`).then(res =>
      res.json()
    )

  const articlesFetcher = () =>
    fetch(
      `${REACT_APP_STRAPI_API_URL}/api/articles?populate=image&locale=${locale}`
    ).then(response => response.json())

  const {
    data: articles,
    isLoading: articlesLoading,
    isError: articleError
  } = useSWR(['api/articles', locale], articlesFetcher)
  const { data: learnpage, isLoading: loading, isError: error } = useFetchPage(
    ['api/learnpage', locale],
    fetcher
  )

  return (
    <QueryWrapper
      loading={loading || articlesLoading}
      error={error || articleError}
    >
      <div className="learn-page">
        <section className="LearnHeaderbg">
          <img
            src={darkMode.value ? DarkModeHeaderImg : HeadeImage}
            alt="headerbg"
            className="header-img"
          />
          <Container>
            <Grid container spacing={2}>
              <Grid item xl={7} lg={7} md={7} sm={12} xs={12}>
                <div className="Learnheadertext">
                  <Typography variant="h2">
                    {learnpage?.herosection?.label}
                  </Typography>
                  <Typography variant="h1">
                    {learnpage?.herosection?.title1}
                  </Typography>
                  <Typography component="p">
                    {learnpage?.herosection?.description}
                  </Typography>
                  <HashLink smooth to="/contact/#top">
                    <Button className="btnLearn disableHover">
                      {learnpage?.herosection?.button.title}
                    </Button>
                  </HashLink>
                </div>
              </Grid>
              <Grid item xl={5} lg={5} md={5} sm={12} xs={12}>
                <div className="headerarrowimg" />
              </Grid>
            </Grid>
          </Container>
        </section>
        <section className="Learn">
          <Container>
            <Typography variant="h1">{learnpage?.articlesTitle}</Typography>
            <Grid
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'flex-start'
              }}
            >
              {articles?.data?.map(article => (
                <Grid
                  container
                  item
                  xl={4}
                  lg={4}
                  md={4}
                  sm={6}
                  xs={12}
                  key={article?.id}
                >
                  <LearnCard to={`/learn/${article?.id}`} className="LearnCard">
                    <div className="image-wrapper">
                      <img
                        src={
                          REACT_APP_STRAPI_API_URL +
                          article?.attributes?.image?.data?.attributes.url
                        }
                        alt=" "
                      />
                    </div>
                    <div className="card_content LearnDetail">
                      <Typography variant="h2">
                        {article.attributes.title}
                      </Typography>
                      <Typography component="p" className="card_content_text ">
                        {convertMarkdownToText(article.attributes.content)}
                      </Typography>
                      <Typography variant="h4">
                        {convertDate(article.attributes.createdAt)}
                        <span>
                          <Timelapse />
                          {readingTime(
                            convertMarkdownToText(article.attributes.content)
                          )}
                        </span>
                      </Typography>
                    </div>
                  </LearnCard>
                </Grid>
              ))}
            </Grid>
          </Container>
        </section>
        {/* <div className="AvaxDetails" style={{ display: 'none' }}>
          <Container>
            <Grid item xs={12}>
              <div className="AvaxInfos">
                <Typography variant="h2">
                  {strapi?.learnDetail?.AvaxContent}
                </Typography>
                {strapi?.learnavaxdetails.map(learnavaxdetail => (
                  <Typography component="p" key={learnavaxdetail.id}>
                    {learnavaxdetail.attributes.AvaxContent}
                  </Typography>
                ))}
                <h3>{strapi?.learnDetail?.BenefitTitle}</h3>
                <ul>
                  {strapi?.learnavaxdetails.map(learnavaxdetail => (
                    <li key={learnavaxdetail.id}>
                      {learnavaxdetail.attributes.BenefitContent}
                    </li>
                  ))}
                </ul>
              </div>
            </Grid>
          </Container>
        </div> */}
        <RedSquare />
        <section className="usBetter">
          <Container>
            <MakesBetter style={{ marginTop: 27 }} />

            {/* <Grid item xs={12}>
            <h1>{learnDetail?.better}</h1>
          </Grid>
          <Grid style={{ display: 'flex', flexWrap: 'wrap' }}>
            {usBetters &&
              usBetters.map(usBetter => (
                <Grid container item xl={3} lg={3} md={3} sm={12} xs={12}>
                  <div className="usBetterDetail">
                    <img
                      src={
                        REACT_APP_STRAPI_API_URL +
                        usBetter?.attributes?.Image?.data[0]?.attributes.url
                      }
                      alt=" "
                      class="img-responsive"
                    />
                    <Typography variant="h2">
                      {usBetter.attributes.name}
                    </Typography>
                    <Typography component="p">
                      {usBetter.attributes.content}
                    </Typography>
                  </div>
                </Grid>
              ))}
          </Grid> */}
          </Container>
        </section>
        <section className="searchBnb">
          <Grid item xs={12}>
            <CallToAction />
          </Grid>
        </section>
      </div>
    </QueryWrapper>
  )
}

export default Learn

const LearnCard = styled(Link)`
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12);
  border-radius: 20px;
  padding-bottom: 20px;
  text-decoration: none !important;

  .image-wrapper {
    position: relative;
    padding-top: 56.25%;
  }
  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
  }
  .card_content {
    padding: 0px 20px;
    padding-top: 4%;

    .card_content_text {
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      white-space: normal;
      overflow: hidden;
    }

    .bottom {
      align-self: flex-end;
    }
  }
`
